/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export const PLUGIN_KEY = {
  FORM: 'Plugin_Form',
  ERROR: 'Plugin_Error',
};
